<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Settlement" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedStore">
                      <option :value="null">Select Store</option>
                      <option :key="index" :value="option" v-for="(option, index) in storeData">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedTerminal">
                      <option :value="null">Select Terminal</option>
                      <option :key="index" :value="option" v-for="(option, index) in terminalData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="terminalLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedChannel">
                      <option :value="null">Select Store</option>
                      <option :key="index" :value="option" v-for="(option, index) in channelData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="channelLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-between align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-3 user_status">
              <button type="button" class="btn btn-primary" @click="onSubmitFilters">Submit</button>
              <button type="button" class="ml-2 btn btn-dark" @click="onClearFilters">Clear</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="">
            <div class="row">
            </div>
          </div>
          <CommonTable
              url="v1/settlements"
              :filteredData="filteredData"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="mutedData"
              customClass="table-hover-animation"
              :exportData="exportData"
              :hidePdfExportButton="true"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  mounted() {
    this.getStoreTerminalChannelData()
  },
  data(){
    return{
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'settlements',
            type:1
          }


          this.downloadReport(requestData)
        }
      },
      filteredData:{type : 'direct' },
      breadcrumb: [
        {name: 'App'},
        {name: 'Settlement'},
        {name: 'Direct'},
      ],
      tableHeaderValues: [
        {
          title: 'UUID',
          valueKey: 'uuid',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-primary">${value}</span>`


            return  html


          }
        },
        {
          title: 'Date(From)',
          valueKey: 'from_date',
        },
        {
          title: 'Date(To)',
          valueKey: 'to_date',
        },
        {
          title: 'Reference',
          valueKey: 'reference',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-primary">${value}</span>`


            return  html


          }
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter: function (value,obj){
            var html=''
            if(obj.status == 3)
              html = `<div class="badge badge-pill  badge-glow badge-success">Done</div>`
            else if(obj.status == 2)
              html = `<div class="badge badge-pill  badge-glow badge-danger">Cancelled</div>`
            else if(obj.status == 0)
              html = `<div class="badge badge-pill  badge-glow badge-warning">Pending</div>`
            else
              html = `<div class="badge badge-pill  badge-glow badge-info">Initiated</div>`


            return html



          }
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</span>`


            return  html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          alter: (value) => {
            return parseFloat(value / 100).toFixed(this.feesDecimalPlaces)
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</span>`


            return  html


          }
        },
        {
          title: 'Settlement Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces)}</span>`


            return  html


          }
        },
        {
          title: 'Account',
          valueKey: 'user_account.currency.code',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-light-success">${value}</a>`

            return html


          }
        },
        {
          title: 'Time/Date',
          valueKey: 'created_at',
         alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: 'Settlement',
          class: 'btn-primary m-1',
          cta: (row, index) => {
            this.$store.commit('setSetSettlementData',row)
            this.$router.push({name: 'direct-settlement-detail',params: {id:row.id}})
          },

        },
      ],
      mutedData: [],
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
    }
  },
  methods:{
    onSubmitFilters() {
      let dataFiltered = {}

      if(this.selectedStore){
        dataFiltered.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        dataFiltered.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        dataFiltered.channelId = this.selectedChannel.id
      }

      dataFiltered.type = 'direct'

      this.filteredData = dataFiltered

    },
    onClearFilters() {

      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {type : 'direct'}


    },
    getStoreTerminalChannelData() {
      this.makeRequest('post', 'v1/get-stores', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            if(responseData){
              if(responseData.stores){
                this.storeData = responseData.stores
              }
            }

          }

        }


      });
    },
  },
  watch:{
    selectedStore(val) {
      this.selectedTerminal = null
      this.terminalData = []
      if(val){
        this.terminalData = val.terminals
      }
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      this.channelData = []
      if(val){
        this.channelData = val.channels
      }
    },
  }
}
</script>

